import React from 'react';
import classnames from 'classnames';
import styles from './AuthLoader.module.scss';

interface AuthLoaderProps {
  type?: string;
}

export const AuthLoader = ({ type }: AuthLoaderProps) => {
  return (
    <div className={classnames(styles.loadingContainer, {
      [styles[`type--${type}`]]: type,
    })}>
      <div className={styles.ldsRing}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};
